import type { GridApi } from 'ag-grid-community'

type FocusRemovalApi<Row> = Pick<
  GridApi<Row>,
  | 'getFocusedCell'
  | 'getDisplayedRowAtIndex'
  | 'getAllDisplayedVirtualColumns'
  | 'clearFocusedCell'
>

export const clearRemovedVirtualizedCellFocus = <Row>(
  api: FocusRemovalApi<Row>,
  removedRows: Row[],
  getRowId: (row: Row) => string | null,
): void => {
  if (!removedRows.length) return
  const focusedCell = api.getFocusedCell()
  if (!focusedCell || focusedCell.rowPinned) return

  const focusedRow = api.getDisplayedRowAtIndex(focusedCell.rowIndex)
  if (!focusedRow?.data) return
  const focusedRowId = getRowId(focusedRow.data)
  if (
    !focusedRowId ||
    !removedRows.some((row) => getRowId(row) === focusedRowId)
  ) {
    return
  }
  if (api.getAllDisplayedVirtualColumns().includes(focusedCell.column)) return

  // AG Grid AG-18636: restoring a removed row's virtualized cell re-enters
  // rendering and leaves the grid locked. Clear only that disappearing focus.
  api.clearFocusedCell()
}
